export default "__VITE_ASSET__kdrWv0XE__"